module.exports = __webpack_public_path__ + "static/logo-438aaf0b79b607042af72a65811ad7f9.png";